import { useNavigation, useRoute } from "@react-navigation/native";
import { Alert } from "react-native";
import { IconButton, useTheme } from "react-native-paper";

import { Header } from "../../../../components";
import useProductFormFormik from "../../hooks/useProductFormFormik";
import { StackScreenProps, productFormRoutes } from "../../navigation/types";
import { unsavedChangesAlert } from "../../utils";

type NavProps = StackScreenProps<typeof productFormRoutes.variantForm>;
export default function VariantFormHeader() {
  const { status, removeVariant } = useProductFormFormik();
  const { colors } = useTheme();

  const route = useRoute<NavProps["route"]>();
  const { goBack } = useNavigation<NavProps["navigation"]>();

  const selectedVariant = route.params?.selectedVariant;
  const isDirty = status?.variantIsDirty || false;

  const onDeleteConfirm = () => {
    removeVariant(selectedVariant);
    goBack();
  };

  const handleDelete = () => {
    Alert.alert(
      "Eliminar variante",
      "¿Estás seguro que deseas eliminar esta variante?",
      [
        { text: "No", style: "cancel", onPress: undefined },
        { text: "Sí", style: "destructive", onPress: onDeleteConfirm },
      ]
    );
  };

  function onBackPress() {
    unsavedChangesAlert({ isDirty, goBack });
  }

  return (
    <Header
      title={`${selectedVariant ? "Editar" : "Crear"} variante`}
      onBackPress={onBackPress}
      rightAction={
        <IconButton
          icon="delete"
          iconColor={colors.error}
          onPress={handleDelete}
        />
      }
    />
  );
}
